var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProcessLaunchWrapper',{attrs:{"description":"","lastBpmnSrc":"Kundenanschaltung_Portierung.bpmn","title":"Telefonnummerportierung"}},[_c('PhoneNumberPortingStart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }